<div>
    <form nz-form (ngSubmit)="submit($event)">
        <div class="flex justify-between items-center mb-4">
            <nz-select
                [(ngModel)]="type"
                name="type"
                [nzOptions]="[
                    { label: 'Call', value: ACTIVITY_TYPES.CALL },
                    { label: 'Email', value: ACTIVITY_TYPES.EMAIL },
                    { label: 'SMS', value: ACTIVITY_TYPES.SMS },
                    { label: 'Other', value: ACTIVITY_TYPES.OTHER }
                ]"
            ></nz-select>
            <div>
                <button
                    nz-button
                    nzType="default"
                    nzShape="round"
                    (click)="closeDrawer()"
                    type="button"
                >
                    Cancel
                </button>
                <button
                    nz-button
                    nzType="primary"
                    nzShape="round"
                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>

        <div *ngIf="type === ACTIVITY_TYPES.CALL" >
            <nz-form-item>
                <nz-form-control required>
                    <label>Call Duration</label>
                    <nz-input-number
                        class="ml-1"
                        [(ngModel)]="form.callDuration"
                        name="callDuration"
                        nzMin="0"
                        nzMax="999"
                        nzStep="1"
                    ></nz-input-number>&nbsp;mins
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-control required>
                    <label>Call Outcome</label>
                    <nz-select
                        [(ngModel)]="form.callOutcome"
                        [nzOptions]="[
                            { label: 'Answered', value: 'Answered' },
                            { label: 'Not Answered', value: 'Not Answered' },
                            { label: 'Voicemail', value: 'Voicemail' },
                            { label: 'Call Back', value: 'Call Back' }
                        ]"
                        name="callOutcome"
                    ></nz-select>
                </nz-form-control>
            </nz-form-item>
        </div>
        <nz-form-item>
            <nz-form-control>
                <label>Admin Note</label>
                <textarea
                    nz-input
                    placeholder="Enter note (optional)"
                    [(ngModel)]="note"
                    rows="4"
                    name="note"
                ></textarea>
            </nz-form-control>
        </nz-form-item>
    </form>
</div>
